import styles from "./ProgressBar.module.scss";

export default function ProgressBar({ progress }) {
  return (
    <div className={`${styles.progressBar}`}>
      <div className={`${styles.progress}`} style={{ width: `${progress}%` }} />
    </div>
  );
}
